import type { RewardFly } from "./rewardFly";

/**
 * The game's reward flight, for screens that want to name where a reward came from (features/rewardFly.ts sets it at
 * boot). A screen never flies anything itself: it says "from this card" and the flight does the rest.
 */
let fly: RewardFly | null = null;

export function setRewardFly(f: RewardFly | null): void { fly = f; }

/** The gain just granted (or about to be saved) came from `el`: it flies from there. */
export function rewardFrom(el: Element | null): void {
  fly?.noteOrigin(el);
  fly?.check();
}
